import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import MappingCreateModalSF from '../../../components/superUser/settings/MappingCreateModalSF'
import MappingUpdateModalSF from '../../../components/superUser/settings/MappingUpdateModalSF'

const MappingListPageUI = ({ context, mappingList, paymentCategoryList, errorList,
  // modes
  createMode, updateMode,
  selectedMapping, mappingGroup, mappedValueList, codeLabelList,
  // event handlers
  onRefreshClick, onOpenCreateModal, onCreateClick, onUpdateClick, onDeleteClick, onCancelClick, onUpdate
}) => {

  const [keywordsExpanded, setKeywordsExpanded] = React.useState(false);
  const [paymentCategoriesExpanded, setPaymentCategoriesExpanded] = React.useState(false);
  const keywordMappings =
    mappingList
      ? mappingList.filter(m => m.mappingGroup === 'bank_analyzer_keywords')
      : [];

  const paymentCategoryMappings =
    mappingList
      ? mappingList.filter(m => m.mappingGroup === 'bank_analyzer_payment_category')
      : [];
  return (
    <SuperUserSettingsPageUI context={context} className='pg_su_mappings' topnav='settings' backLink='/su/settings'
      headerText='Global bank analyzer keywords' centered={!mappingList && !errorList} page='baKeywords'
    >
      {
        !mappingList && !errorList &&
        <SpinnerComponentUI />
      }
      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }
      {
        mappingList &&
        <>
          <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Global bank analyzer keywords' />
          <LRTableActionsUI location='top'
            left={
              <ActionLeftUI ontext={context} onRefreshClick={onRefreshClick} />
            }
            right={<span />}
          />
        </>
      }
      {
        mappingList && mappingList.length === 0 &&
        <div className='g_text_center g_m_top_200'>No mappings yet</div>
      }

      {
        mappingList && mappingList.length !== 0 &&
        <>
          <ExpandableHeaderUI
            title='Keywords'
            expanded={keywordsExpanded}
            onClick={() => setKeywordsExpanded(!keywordsExpanded)}
            onCreateClick={() =>
              onOpenCreateModal('bank_analyzer_keywords')
            }
          />

          {
            keywordsExpanded &&
            <MappingListUI
              context={context}
              mappingList={mappingList}
              showCreditDebit={true}
              mappedValueList={mappedValueList}
              codeLabelList={codeLabelList}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
            />
          }

          <ExpandableHeaderUI
            title='Payment Categories'
            expanded={paymentCategoriesExpanded}
            onClick={() =>
              setPaymentCategoriesExpanded(!paymentCategoriesExpanded)
            }
            onCreateClick={() =>
              onOpenCreateModal('bank_analyzer_payment_category')
            }
          />

          {
            paymentCategoriesExpanded &&
            <MappingListUI
              context={context}
              mappingList={paymentCategoryList || []}
              showCreditDebit={false}
              mappedValueList={mappedValueList}
              codeLabelList={codeLabelList}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
            />
          }
        </>
      }

      <MappingCreateModalSF
        context={context}
        createMode={createMode}
        mappingGroup={mappingGroup}
        mappedValueList={mappedValueList}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
      />

      <MappingUpdateModalSF
        context={context}
        updateMode={updateMode}
        mappedValueList={mappedValueList}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
        selectedMapping={selectedMapping}
      />
    </SuperUserSettingsPageUI>
  );
};
const ExpandableHeaderUI = ({
  title,
  expanded,
  onClick,
  onCreateClick
}) =>
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px'
    }}
  >
    <div
      onClick={onClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <span>{expanded ? '▼' : '▶'}</span>
      <strong className='g_m_left_50'>{title}</strong>
    </div>

    <IconButtonUI
      icon='icon-plus'
      onClick={onCreateClick}
    />
  </div>;

const MappingListUI = ({ context, mappingList, showCreditDebit, mappedValueList, codeLabelList, onRefreshClick, onUpdateClick, onDeleteClick }) =>
  <div className='su_mappings'>
    <div className='g_flex_h'
      style={{
        justifyContent: 'space-between',
        padding: '10px 16px',
        fontWeight: 600,
        borderBottom: '1px solid #ddd'
      }}>
      <span>
        {showCreditDebit ? 'Keyword' : 'Payment Category'}
      </span>

      <span>
        Bank Analyzer Category
      </span>
    </div>

    <LRTableBodyUI>
      {
        mappingList.map((mapping, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} mapping={mapping} codeLabelList={codeLabelList} showCreditDebit={showCreditDebit} />}
            right={<RowRightUI mapping={mapping} mappedValueList={mappedValueList} onUpdateClick={onUpdateClick} onDeleteClick={onDeleteClick} showCreditDebit={showCreditDebit} />}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const RowLeftUI = ({ context, mapping, codeLabelList, showCreditDebit }) => {
  const matchedCode =
    codeLabelList.filter(c => c.code === mapping.mappedValue)[0];

  return (
    <div className='g_flex_h'>
      <span>{mapping.sourceValue}</span>
      {
        showCreditDebit &&
        <i className='g_m_left_100'>
          {matchedCode && matchedCode.credit ? 'credit' : 'debit'}
        </i>
      }
    </div>
  );
};
const RowRightUI = ({ mapping, mappedValueList, onUpdateClick, showCreditDebit, onDeleteClick }) => {
  const matchedValue =
    mappedValueList.filter(val => val.key === mapping.mappedValue)[0];

  return (
    <div className='g_flex_h'>
      <span>{matchedValue ? matchedValue.value : ''}</span>
      {
        showCreditDebit ?
          (
            <span
              className='icon icon-pencil g_link_2 g_m_left_50'
              data-mapping-id={mapping.mappingId}
              onClick={onUpdateClick}
            />
          )
          : (
            <span
              className='icon icon-trash-o g_m_left_25 g_cursor_pointer g_muted'
              data-mapping-id={mapping.mappingId}
              onClick={onDeleteClick}
            />
          )
      }
    </div>
  );
};

const ActionLeftUI = ({ context, onRefreshClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
  </div>

export default MappingListPageUI
